import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Col, Select, Row } from "antd";
import "./dm-language-selector.css";

const { Option } = Select;

const bottomRight = {
  points: ["tl", "bl"],
  offset: [0, 4],
  targetOffset: [35, 4],
  overflow: {
    adjustX: 0,
    adjustY: 1,
  },
};

export function LanguageSelector(props) {
  const {
    onChange,
    languages = [],
    defaultValue = "es",
    dropdownClassName = "ant-dropdown-placement-bottomRight",
  } = props;

  const [selectStatus, setSelectStatus] = useState(false);
  return (
    <Select
      open={selectStatus}
      className="language-select language-select-item"
      optionLabelProp="label"
      style={{ textAlign: "end" }}
      defaultValue={defaultValue}
      dropdownMatchSelectWidth={100}
      dropdownClassName={`language-select-dropdown ${dropdownClassName}`}
      dropdownStyle={{ zIndex: 2000 }}
      dropdownAlign={bottomRight}
      onChange={onChange}
      onMouseEnter={() => setSelectStatus(true)}
      onMouseLeave={() => setSelectStatus(false)}
      onSelect={() => setSelectStatus(false)}
    >
      {languages.map((item) => (
        <Option
          value={item.key}
          label={item.key}
          className="language-select-item"
        >
          <Row>
            <Col span={6}> {item.label}</Col>
          </Row>
        </Option>
      ))}
    </Select>
  );
}

LanguageSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  languages: PropTypes.array,
  defaultValue: PropTypes.string,
  dropdownClassName: PropTypes.string,
};

LanguageSelector.defaultProps = {
  onChange: (msg) => window.alert(`Valor de idioma seleccionado: ${msg}`),
  languages: [],
};
